"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplementalTypeInfoStatic = void 0;
/* eslint-disable no-unused-vars */
/* eslint-disable sort-imports */
const supplementalTypeCollectionImpl_1 = require("./supplementalTypeCollectionImpl");
class SupplementalTypeInfoStatic {
    static retrieveSupplementalTypeCollection() {
        return this.supplementalTypeCollection;
    }
}
exports.SupplementalTypeInfoStatic = SupplementalTypeInfoStatic;
SupplementalTypeInfoStatic.supplementalTypeCollection = new supplementalTypeCollectionImpl_1.SupplementalTypeCollectionImpl();
//# sourceMappingURL=supplementalTypeInfoStatic.js.map